import React, { createContext, useState, useEffect } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Load any existing customers from localStorage, if present
  const [customers, setCustomers] = useState(() => {
    const saved = localStorage.getItem('customers');
    return saved ? JSON.parse(saved) : [];
  });

  const [selectedCustomerId, setSelectedCustomerId] = useState(null);

  // Whenever customers changes, persist to localStorage
  useEffect(() => {
    localStorage.setItem('customers', JSON.stringify(customers));
  }, [customers]);

  return (
    <AppContext.Provider
      value={{ customers, setCustomers, selectedCustomerId, setSelectedCustomerId }}
    >
      {children}
    </AppContext.Provider>
  );
};
